import { render, staticRenderFns } from "./PantallaBienvenida.vue?vue&type=template&id=867eaa16"
import script from "./PantallaBienvenida.vue?vue&type=script&lang=js"
export * from "./PantallaBienvenida.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports